import React, {useEffect, useCallback} from 'react';
import {SeriesModalAction} from "../../reducers/seriesModalReducer.ts";
import SmartIcon from "../SmartIcon.tsx";
import {titleCase} from "../../utils/utils.ts";
import {SeriesGenresEnum} from "../../models/enums/seriesGenres.enum.ts";

interface SeriesModalGenresTabProps {
  genres: SeriesGenresEnum[];
  dispatch: React.ActionDispatch<[action: SeriesModalAction]>
}


const SeriesModalGenresTab: React.FC<SeriesModalGenresTabProps> = (
  {
    genres,
    dispatch,
  }: SeriesModalGenresTabProps
) => {
  const [candidateGenre, setCandidateGenre] = React.useState<SeriesGenresEnum | null>(null);

  const handleAddGenre = useCallback(() => {
    if (!candidateGenre || genres.includes(candidateGenre)) return;

    dispatch({
      type: "SET_GENRES",
      payload: [...genres, candidateGenre]
    });
    setCandidateGenre(null);
  }, [candidateGenre, genres, dispatch]);

  const onEnterClicked = useCallback(() => {
    handleAddGenre();
  }, [handleAddGenre]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        onEnterClicked();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onEnterClicked]);


  return (
    <div>
      <div className="mb-6 h4">Genres</div>
      {/*<div className="flex items-center justify-between w-full">*/}
      {/*  <Field*/}
      {/*    className="w-full"*/}
      {/*    classInput={"border border-brandPurple-500"}*/}
      {/*    label="Add New Genre"*/}
      {/*    placeholder="Enter genre name"*/}
      {/*    value={candidateGenre}*/}
      {/*    onChange={(event) => setCandidateGenre(event.target.value)}*/}
      {/*  />*/}
      {/*  <div*/}
      {/*    className="p-3 mt-8 ml-3 border rounded-xl cursor-pointer hover:border-brandPurple-500  active:scale-95 transition-transform fill-n-400 hover:fill-brandPurple-500"*/}
      {/*    onClick={handleAddGenre}*/}
      {/*  >*/}
      {/*    <SmartIcon name={'plus'}/>*/}
      {/*  </div>*/}
      {/*</div>*/}
      <div className="flex flex-wrap mt-4 gap-2">
        {genres.map((genre, index) => (
          <div
            key={index}
            className="px-2 bg-n-2 border rounded-xl  bg-n-600 border-n-500 text-n-300 flex items-center justify-between"
          >
            <span className="text-xs">{titleCase(genre)}</span>
            <div
              className="ml-2 cursor-pointer hover:fill-brandPurple-500 active:scale-95 transition-transform fill-n-400"
              onClick={() => {
                dispatch({
                  type: "SET_GENRES",
                  payload: genres.filter((g) => g !== genre)
                });
              }}
            >
              <SmartIcon name={'close'} className="w-4 h-4"/>
            </div>
          </div>
        ))}
      </div>
      <div className="flex flex-col mt-4">
        <span className="text-md my-6">Suggested Genres</span>
        <div className="flex flex-wrap gap-2">
          {Object.values(SeriesGenresEnum)
            .filter((genre: SeriesGenresEnum) => !genres.includes(genre as SeriesGenresEnum))
            .map((genre: SeriesGenresEnum, index: number) => {
              const enumGenre = genre as SeriesGenresEnum;
              return (
                <div
                  key={index}
                  className="px-2 bg-n-2 border rounded-xl bg-n-600 border-n-500 text-n-300 flex items-center justify-between hover:text-brandPurple-500 fill-n-400 hover:fill-brandPurple-500 cursor-pointer"
                  onClick={() => {
                    if (!genres.includes(enumGenre)) {
                      dispatch({
                        type: "SET_GENRES",
                        payload: [...genres, enumGenre],
                      });
                    }
                  }}
                >
                  <span className="text-xs">{titleCase(enumGenre)}</span>
                  <div
                    className="ml-2 active:scale-95 transition-transform"
                  >
                    <SmartIcon name="plus" className="w-4 h-4"/>
                  </div>
                </div>
              );
            })}
        </div>
      </div>

    </div>
  )
}

export default SeriesModalGenresTab;